import { useState, useEffect, useRef, useCallback } from 'react'
import * as moment from 'moment'

import { useAccounts } from '../api/users'
import Page from '../components/Page'

const Percentage = ({ numerator, denomirator }) => {
  if (!denomirator) return null

  const fraction = (100 * numerator) / denomirator
  const text = fraction === 100 ? fraction.toString() : fraction.toFixed(2)

  return <span className="text-xs">({text}%)</span>
}

const Factor = ({ numerator, denomirator }) => {
  if (!denomirator) return null

  const fraction = numerator / denomirator
  const text = fraction === 1 ? fraction.toString() : fraction.toFixed(2)

  return <span className="text-xs">({text}x)</span>
}

const ExpirationField = ({ value }) => {
  const exp = moment(value)
  const format = moment().add(60, 'days').isBefore(exp, 'day') ? '' : 'text-red-400'
  return <span className={`text-xs ${format}`}>{value}</span>
}

const PlanField = ({ value }) => {
  const format = value === 'PLUS' ? 'bg-amber-600' : 'bg-slate-300'
  return (
    <span className={`rounded px-2 py-1 mr-1 leading-loose whitespace-nowrap text-white ${format}`}>
      {value}
    </span>
  )
}

const AccountsPage = () => {
  const [accounts, setAccounts] = useState([])
  const { fetchAccounts } = useAccounts()

  useEffect(() => {
    fetchAccounts().then((accounts) => {
      setAccounts(accounts)
    })
  }, [])

  return (
    <Page
      actions={[
        {
          title: 'Demo törlése',
          onClick: () => {
            console.log('demo törltése')
          },
        },
      ]}
    >
      <div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Név
                </th>
                <th scope="col" className="px-6 py-3">
                  Előfizetés
                </th>
                <th scope="col" className="px-6 py-3">
                  Lejárat
                </th>
                <th scope="col" className="px-6 py-3">
                  Listák száma
                </th>
                <th scope="col" className="px-6 py-3">
                  Listák elemei
                </th>
                <th scope="col" className="px-6 py-3">
                  Különböző jogszabályok
                </th>
                <th scope="col" className="px-6 py-3">
                  Egyedi jogszabályok
                </th>
                <th scope="col" className="px-6 py-3">
                  Nem változott
                </th>
                <th scope="col" className="px-6 py-3">
                  Unified law nums
                </th>
                <th scope="col" className="px-6 py-3">
                  Változások száma
                </th>
                <th scope="col" className="px-6 py-3">
                  Ráosztott költség
                </th>
                <th scope="col" className="px-6 py-3">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {accounts &&
                accounts.map((account) => {
                  return (
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="px-6 py-2">{account.account_name}</td>
                      <td className="px-6 py-2">
                        <PlanField value={account.plan} />
                      </td>
                      <td className="px-6 py-2">
                        <ExpirationField value={account.max_age} />
                      </td>
                      <td className="px-6 py-2">{account.used_list_nums}</td>
                      <td className="px-6 py-2">{account.item_nums}</td>
                      <td className="px-6 py-2">
                        {account.law_nums}{' '}
                        <Percentage numerator={account.law_nums} denomirator={account.item_nums} />
                      </td>
                      <td className="px-6 py-2">
                        {account.unique_nums}{' '}
                        <Percentage
                          numerator={account.unique_nums}
                          denomirator={account.law_nums}
                        />
                      </td>
                      <td className="px-6 py-2">
                        {account.unchanged_nums}{' '}
                        <Percentage
                          numerator={account.unchanged_nums}
                          denomirator={account.law_nums}
                        />
                      </td>
                      <td className="px-6 py-2">
                        {account.unified_law_nums.toFixed(1)}{' '}
                        <Percentage
                          numerator={account.unified_law_nums}
                          denomirator={account.law_nums}
                        />
                      </td>
                      <td className="px-6 py-2">
                        {account.modification_nums}{' '}
                        <Factor
                          numerator={account.modification_nums}
                          denomirator={account.law_nums - account.unchanged_nums}
                        />
                      </td>
                      <td className="px-6 py-2">{account.account_cost.toFixed(1)}</td>
                      <td className="px-6 py-2 text-right">
                        <a
                          href="#"
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          Edit
                        </a>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  )
}

export default AccountsPage
